import GetCompanyByIdRequestModelBase from '../_generated/modelBases/get-company-by-id-request-model-base';

export default class GetCompanyByIdRequestModel extends GetCompanyByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
